import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";

export default function ShopifyCollection() {
  const componentCreatedRef = useRef(false);
  
  useEffect(() => {
    
    const loadShopifyBuy = () => {
      const existingScript = document.getElementById("shopify-buy-sdk");

      if (existingScript) {
        if (window.ShopifyBuy && window.ShopifyBuy.UI) {
          ShopifyBuyInit();
        } else {
          existingScript.addEventListener("load", ShopifyBuyInit);
        }
        return;
      }

      const script = document.createElement("script");
      script.id = "shopify-buy-sdk";
      script.src =
        "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";
      script.async = true;
      script.onload = ShopifyBuyInit;
      document.body.appendChild(script);
    };

    const ShopifyBuyInit = () => {
      if (!window.ShopifyBuy || !window.ShopifyBuy.UI) return;
      
      // Prevent duplicate component creation
      if (componentCreatedRef.current) {
        console.log("⚠️ Component already created, skipping...");
        return;
      }

      const client = window.ShopifyBuy.buildClient({
        domain: "ftkxip-98.myshopify.com",
        storefrontAccessToken: "eec31b9113ae27d856b8088ed32ca717",
      });

      window.ShopifyBuy.UI.onReady(client).then((ui) => {
        console.log("🛍️ Shopify Buy Button UI ready, creating collection component...");
        
        const containerNode = document.getElementById("collection-component-1762886026670");
        if (!containerNode) {
          console.error("❌ Container node not found!");
          return;
        }
        
        // Check if component already exists in container
        if (containerNode.children.length > 0) {
          console.log("⚠️ Container already has content, clearing it first...");
          containerNode.innerHTML = "";
        }
        
        try {
          componentCreatedRef.current = true;
          ui.createComponent("collection", {
            id: "490790256944",
            node: containerNode,
            moneyFormat: "%24%7B%7Bamount%7D%7D",
            options: {
            product: {
              contents: {
                img: true,
                imgWithCarousel: false,
                title: true,
                price: true,
                button: true,
              },
              styles: {
                product: {
                  width: "280px",
                  margin: "0 10px",
                  borderRadius: "16px",
                  boxShadow: "0 6px 20px rgba(230, 57, 38, 0.15)",
                  transition: "all 0.3s ease-in-out",
                  backgroundColor: "#fff",
                  position: "relative",
                  border: "2px solid transparent",
                  "@media (hover: hover)": {
                    ":hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 12px 30px rgba(230, 57, 38, 0.25)",
                      borderColor: "#e63926",
                    },
                  },
                },
                imgWrapper: {
                  position: "relative",
                  overflow: "hidden",
                  backgroundColor: "#f9f9f9",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  minHeight: "280px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
                img: {
                  width: "100%",
                  height: "auto",
                  maxHeight: "280px",
                  objectFit: "contain",
                  display: "block",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  padding: "10px",
                },
                button: {
                  backgroundColor: "#e63926",
                  color: "#fff",
                  fontWeight: "600",
                  borderRadius: "8px",
                  padding: "12px 24px",
                  fontSize: "16px",
                  transition: "all 0.2s ease",
                  ":hover": {
                    backgroundColor: "#c62f1e",
                  },
                  ":focus": {
                    backgroundColor: "#c62f1e",
                  },
                },
                title: {
                  fontWeight: "600",
                  color: "#222",
                  fontSize: "18px",
                },
                price: {
                  fontWeight: "700",
                  color: "#e63926",
                  fontSize: "20px",
                },
              },
              buttonDestination: "checkout",
              text: { button: "Buy Now" },
            },
            productSet: {
              styles: {
                products: {
                  display: "flex",
                  overflowX: "auto",
                  scrollBehavior: "smooth",
                  WebkitOverflowScrolling: "touch",
                  gap: "16px",
                  padding: "10px",
                },
              },
            },
            modalProduct: {
              contents: {
                img: false,
                imgWithCarousel: true,
                button: false,
                buttonWithQuantity: true,
              },
              text: { button: "Add to cart" },
            },
            cart: {
              text: { total: "Subtotal", button: "Checkout" },
            },
          },
        });
        console.log("✅ Shopify collection component created successfully");
        } catch (error) {
          console.error("❌ Error creating Shopify collection component:", error);
        }
        
        // Check for products and images after delays to allow rendering
        setTimeout(() => {
          const container = document.getElementById("collection-component-1762886026670");
          if (container) {
            const products = container.querySelectorAll('[data-shopify-buy-product]');
            console.log(`📦 Found ${products.length} products in collection`);
            
            const images = container.querySelectorAll("img");
            console.log(`🖼️ Found ${images.length} images in collection`);
            
            if (images.length === 0) {
              console.warn("⚠️ No images found! This could mean:");
              console.warn("   1. Products in Shopify don't have images uploaded");
              console.warn("   2. Collection is empty");
              console.warn("   3. Images are loading but not yet rendered");
            }
            
            images.forEach((img, index) => {
              console.log(`Image ${index + 1}:`, {
                src: img.src,
                alt: img.alt,
                width: img.width,
                height: img.height,
                naturalWidth: img.naturalWidth,
                naturalHeight: img.naturalHeight,
                visible: img.offsetWidth > 0 && img.offsetHeight > 0,
              });
              
              // Check if image loaded successfully
              if (img.complete && img.naturalWidth === 0) {
                console.warn(`⚠️ Image ${index + 1} failed to load:`, img.src);
              }
            });
          } else {
            console.error("❌ Container not found after component creation");
          }
        }, 3000);
      }).catch((error) => {
        console.error("❌ Error initializing Shopify Buy Button UI:", error);
      });
    };

    loadShopifyBuy();
    
    // Cleanup function to prevent duplicate renders
    return () => {
      componentCreatedRef.current = false;
      const containerNode = document.getElementById("collection-component-1762886026670");
      if (containerNode) {
        containerNode.innerHTML = "";
      }
    };
  }, []);

  return (
    <>
      <style>{`
        /* Target Shopify Buy Button images directly */
        #collection-component-1762886026670 img,
        [data-shopify-buy-product] img,
        .shopify-buy__product img {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          width: 100% !important;
          height: auto !important;
          max-height: 280px !important;
          object-fit: contain !important;
          background-color: #f9f9f9 !important;
          padding: 10px !important;
        }
        
        /* Ensure image wrapper is visible */
        [data-shopify-buy-product] > div:first-child,
        .shopify-buy__product__media-wrapper {
          min-height: 280px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          background-color: #f9f9f9 !important;
          border-top-left-radius: 16px !important;
          border-top-right-radius: 16px !important;
        }
      `}</style>
      <Box
        sx={{
          width: "100%",
          maxWidth: "1400px",
          mx: "auto",
          overflow: "hidden",
          py: 6,
          px: 2,
          background: "linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%)",
          textAlign: "center",
          borderRadius: 2,
          my: 4,
        }}
      >
      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontWeight: 700,
          mb: 1,
          color: "#e63926",
          letterSpacing: "0.5px",
          fontFamily: "Poppins, sans-serif",
          textTransform: "uppercase",
        }}
      >
        Shop Our Collection
      </Typography>
      
      <Typography
        variant="body1"
        sx={{
          mb: 4,
          color: "#666",
          fontWeight: 500,
        }}
      >
        Quality automotive gear and accessories for car enthusiasts
      </Typography>

      <Box
        id="collection-component-1762886026670"
        sx={{
          display: "flex",
          overflowX: "auto",
          scrollBehavior: "smooth",
          WebkitOverflowScrolling: "touch",
          gap: 3,
          px: 2,
          pb: 2,
          justifyContent: "center",
          "&::-webkit-scrollbar": {
            height: "8px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#e63926",
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#c62f1e",
            },
          },
        }}
      ></Box>
    </Box>
    </>
  );
}
